module.exports = {
      id: "icon-heading-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-heading",
      toString: function () {
        return this.url;
      }
    }